module.exports = {
  page_header: 'Апелляции',
  hints: {
    monitoring_view: 'Просмотр мониторинга'
  },
  filter: {
    dt_create: 'Дата создания',
    dt_sent: 'Дата подачи',
    dt_processing: 'Дата обработки',
    operator: 'Инициатор апелляции',
    сontroller: 'Контролёр',
    inspect: 'Проверяющий',
    mfs: 'Мониторинговая форма',
    status: 'Статус апелляции',
    resolution: 'Резолюция',
    statuses: {
      CREATED: 'апелляция создана',
      SENT: 'апелляция отправлена',
      CLOSED: 'апелляция закрыта',
      IN_WORK: 'апелляция на рассмотрении',
      DECLINED: 'апелляция отклонена',
      ACCEPTED: 'апелляция принята',
    },
    resolutions: {
      OPERATOR_ERROR: 'ошибка оператора',
      CONTROLLER_ERROR: 'ошибка контролёра',
      NO_ERROR: 'нет ошибок сотрудников',
    }
  }
}